import React from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import {connect} from 'react-redux';
import Button from 'react-bootstrap/lib/Button';
import * as actions from '../../../actions/response';
import ClaroUrlBuilder from '../../../utils/ClaroUrlBuilder';
import { GetRegion } from '../../../constants';
import Utils from '../../../utils/Utils';
import * as metricsActions from '../../../action-creators/metrics';
import {converter} from '../../../helpers/converter';

import { get } from 'lodash';
import { getCounterValidEmail } from '../../../action-creators/ip_telmex';

const classButtonInactive = 'btn btn-default close-modal btn-block';


class ModalSuccessSimple extends React.Component {
  constructor(props) {
    super(props);
    this.closeModal = this.closeModal.bind(this);
    this.onPlay = this.onPlay.bind(this);

    // Set Metrics
    props.setMetricsEvent({
      type: 'executor',
      success: true,
    });
  }

  handleClick = (next) => {
    const userMailValidation = JSON.parse(
      this.props.metadata.user_mail_validation
    );
    const counter = get(userMailValidation, 'mexico.limit');
    this.props
      .getCounterValidEmail(counter, next.bind(this))
      .then(wait => !wait && next());
  }

  closeModal() {
    const { group_id} = this.props.queryParams;
    const redirect = () => {
      if (group_id) {
        return window.location.replace(ClaroUrlBuilder.card(GetRegion(), group_id));
      } else {
        this.props.closeModal("RentaSuccess");
      }
    };
    redirect();
  }

  onPlay(){    
    const params = this.props.queryParams;

      const isMobile = Utils.MobileCheck();
     if (isMobile) {
              this.props.closeModal("RentaSuccess");
      return this.props.navigate(`/${GetRegion()}/devices?runplayerinapp&group_id=${params.group_id}`);

    } else {
    const redirect = () => {
      const formContent = params.group_id;
      const playerUrl = params.player_url;
      if (formContent && playerUrl) {
        return window.location.replace(decodeURIComponent(playerUrl));
      }
      window.location.replace(ClaroUrlBuilder.home());
    };
    redirect();
    }
  }

  renderPlayButton() {

    if(this.props.noShowPlay) {
      return
    }

    return <Button
            className={ classButtonInactive }
            onClick={() => this.handleClick(this.onPlay)}>
            { converter.convertApaUnicode(this.props.translations, 'detail_play', 'Ver')}
            <i className='fa fa-play padding-0-5'/>
    </Button> 
  }

  render() {
    return (
      <Modal show={true}>
        <Modal.Header>
          <Button className="close close-modal" onClick={() => this.handleClick(this.closeModal)}>x</Button>
          <h4 className="text-center">{this.props.title}</h4>
        </Modal.Header>
        <Modal.Body className='modal-body text-center success'>
          <i className="fa text-center fa-3x fa-check"></i>
          <p className='padding-top-2' dangerouslySetInnerHTML={
          {__html: this.props.message}
          }></p>
        </Modal.Body>
        <Modal.Footer>
          <div className="footer-modal-button flex-end">
            <div className="col-lg-3 col-md-3 col-sm-4 col-xs-12 padding-top-05">
              {this.renderPlayButton()}            
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    )
  }
}

const mapStateToProps = state => {
  return {
    translations: state.translations,
    router: state.routing,
    metadata: state.metadata,
  };
};

const mapDispatchToProps = (dispatch) => ({
  closeModal(modalType) {
    dispatch(actions.removeModal(modalType));
  },
  setMetricsEvent(options) {
    dispatch(metricsActions.setMetricsEvent(options));
  },
  getCounterValidEmail(count, next) {
    return dispatch(getCounterValidEmail(count, next));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSuccessSimple);
